<template>
  <section id="agent" class="section">
    <div class="container">
      <div class="section-head">
        <span class="eyebrow">渠道合作</span>
        <h2 class="section-title">诚招全国代理</h2>
        <p class="section-sub">
          {{ appName }} 软件 OEM 贴牌 / 卡密销售合作，零门槛分润、技术全程扶持，共享企业服务市场。
        </p>
      </div>

      <div class="agent-grid">
        <article v-for="(card, i) in cards" :key="i" class="agent-card">
          <div class="agent-index">0{{ i + 1 }}</div>
          <h3 class="agent-title">{{ card.title }}</h3>
          <ul class="agent-list">
            <li v-for="(li, j) in card.items" :key="j">{{ li }}</li>
          </ul>
        </article>
      </div>

      <div class="agent-cta">
        <a class="btn btn--dark" href="#contact" @click.prevent="scrollTo('contact')">
          咨询代理合作
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { DR_APP_NAME } from "../../appName";

export default {
  name: "AgentSection",
  data() {
    return {
      appName: DR_APP_NAME,
      cards: [
        {
          title: "OEM 贴牌合作",
          items: ["支持 LOGO / UI / 域名 100% 自定义", "品牌独立后台管理系统"]
        },
        {
          title: "卡密批发销售",
          items: ["阶梯式折扣", "实时卡密生成系统", "防窜货区域保护机制"]
        },
        {
          title: "技术全程扶持",
          items: ["专属对接群，一对一答疑", "免费提供推广素材与话术"]
        }
      ]
    };
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.agent-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.agent-card {
  position: relative;
  padding: 30px 28px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-sm);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.agent-card:hover {
  transform: translateY(-3px);
  border-color: rgba(31, 162, 240, 0.28);
  box-shadow: var(--shadow-md);
}

.agent-index {
  color: var(--brand);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  margin-bottom: 14px;
}

.agent-title {
  color: var(--text-1);
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 16px;
  letter-spacing: -0.01em;
}

.agent-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agent-list li {
  position: relative;
  padding-left: 22px;
  color: var(--text-2);
  font-size: 14.5px;
  line-height: 1.65;
}

.agent-list li::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 2px;
  width: 12px;
  height: 7px;
  border-left: 2px solid var(--brand-green);
  border-bottom: 2px solid var(--brand-green);
  transform: rotate(-45deg);
}

.agent-cta {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 26px;
  border-radius: var(--r-full);
  font-size: 15px;
  font-weight: 600;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.btn svg {
  width: 16px;
  height: 16px;
}

.btn--dark {
  background: var(--ink);
  color: #fff;
  box-shadow: 0 6px 20px rgba(17, 24, 39, 0.16);
}

.btn--dark:hover {
  background: #000;
  transform: translateY(-1px);
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.24);
}

@media (max-width: 900px) {
  .agent-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
  .agent-card {
    padding: 22px;
  }
}
</style>
